module.exports = __webpack_public_path__ + "static/media/BannerRegistroEN.f6284b5d.jpg";